import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/AppLogo.png'


const _hoisted_1 = { key: 1 }

import { useRouter } from "vue-router";
import { routes } from "../router/routes";
import { computed, ref } from "vue";
import { useLoginUserStore } from "@/store/useStore";
import checkAccess from "@/access/checkAccess";
import { userLogoutUsingPost } from "@/api/userController";
import removeToken from "@/utils/auth";


export default /*@__PURE__*/_defineComponent({
  __name: 'GboalHeader',
  setup(__props) {

const loginUserStore = useLoginUserStore();
const router = useRouter();

const selectKeys = ref(["/"]);

router.afterEach((to, from, failure) => {
  selectKeys.value = [to.path];
});

//跳转事件
const doMenuClick = (key: string) => {
  router.push({
    path: key,
  });
};

const doLogin = () => {
  router.push({
    path: "/user/login",
  });
};

// 下拉菜单触发
const handleDropdownClick = (value: string) => {
  if (value === "logout") {
    doLogout();
  }
};

const doLogout = async () => {
  try {
    // 第一步：调用后端接口，此时 localStorage 中的 Token 还存在，请求头能带上 Token
    const res = await userLogoutUsingPost();

    if (res.data?.code === 0) {
      // 第二步：只有后端返回成功，才清理本地 Token 和用户信息
      // 假设你的 store 有 logout 方法，或者手动重置
      loginUserStore.reset(); // 或者 yourStore.logout()

      // 第三步：清理 Token
      removeToken();

      router.push({
        path: "/user/login",
        // 可以带上 redirect 参数，回来时自动跳转到之前的页面
        query: { redirect: router.currentRoute.value.fullPath },
      });
    } else {
      console.error("退出登录接口调用失败:", res.data);
      // 这里处理接口失败的情况（例如：token 已过期，此时可以强制清理）
      // 强制清理本地状态并跳转
      loginUserStore.reset();
      removeToken();
      router.push("/user/login");
    }
  } catch (e) {
    // 如果请求本身发送失败（如网络错误），也尝试清理本地状态
    loginUserStore.reset();
    removeToken();
    router.push("/user/login");
  }
};

//显隐条件
const visibleRoutes = computed(() => {
  return routes.filter((item) => {
    if (item.meta?.hideInMenu) {
      return false;
    }
    //根据权限过滤菜单
    if (!checkAccess(loginUserStore.loginUser, item.meta?.access as string)) {
      return false;
    }
    return true;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_icon_export = _resolveComponent("icon-export")!
  const _component_a_doption = _resolveComponent("a-doption")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, {
    id: "globalHeader",
    align: "center",
    wrap: false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { flex: "auto" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_menu, {
            mode: "horizontal",
            onMenuItemClick: doMenuClick,
            "selected-keys": selectKeys.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_menu_item, {
                key: "0",
                style: { padding: 0, marginRight: '38px' },
                disabled: ""
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("div", { class: "title-bar" }, [
                    _createElementVNode("img", {
                      class: "logo",
                      src: _imports_0,
                      alt: "app logo"
                    }),
                    _createElementVNode("div", { class: "title" }, "智答答")
                  ], -1)
                ]))]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleRoutes.value, (item) => {
                return (_openBlock(), _createBlock(_component_a_menu_item, {
                  key: item.path
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["selected-keys"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, { flex: "100px" }, {
        default: _withCtx(() => [
          (_unref(loginUserStore).loginUser.id)
            ? (_openBlock(), _createBlock(_component_a_dropdown, {
                key: 0,
                onSelect: handleDropdownClick
              }, {
                content: _withCtx(() => [
                  _createVNode(_component_a_doption, { value: "logout" }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_icon_export)
                    ]),
                    default: _withCtx(() => [
                      _cache[1] || (_cache[1] = _createTextVNode(" 退出登录 ", -1))
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_space, { style: {"cursor":"pointer"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_avatar, {
                        size: 24,
                        style: { marginRight: '8px' },
                        "image-url": _unref(loginUserStore).loginUser.userAvatar
                      }, null, 8, ["image-url"]),
                      _createVNode(_component_a_typography_text, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(loginUserStore).loginUser.userName ?? "匿名"), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: doLogin
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("登录", -1)
                  ]))]),
                  _: 1
                })
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})